import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface IUpdateShouldSuppressDataOrientationAutoOpenParams {
  user: string;
  shouldSuppressAutoOpen: boolean;
}

export class UpdateShouldSuppressDataOrientationAutoOpenRequest extends Request<IUpdateShouldSuppressDataOrientationAutoOpenParams, IResult> {
  constructor(params: IUpdateShouldSuppressDataOrientationAutoOpenParams) {
    super('updateShouldSuppressDataOrientationAutoOpen', params);
  }
}
